import React from "react";
import { PaymentForm, CreditCard } from "react-square-web-payments-sdk";
const SearchEngine = () => {
  return (
    <div style={{ height: "100vh", width: "100%", border: "none" }}>
       <PaymentForm
          applicationId={import.meta.env.VITE_SUBSCRIPTION_SQAURE_APPLICATION_ID}
          locationId={import.meta.env.VITE_SUBSCRIPTION_SQAURE_LOCATION_ID}
          overrides={{
            scriptSrc:
              import.meta.env.VITE_SUBSCRIPTION_SQAURE_ENV === "production"
                ? "https://web.squarecdn.com/v1/square.js"
                : "https://sandbox.web.squarecdn.com/v1/square.js",
          }}
          cardTokenizeResponseReceived={(token,buyer)=>{}}
          createPaymentRequest={() => ({
            countryCode: "GB",
            currencyCode: "GBP",
            total: { label: "Seamless Slot", amount: "1.00" },
          })}
          createVerificationDetails={() => ({
            amount: "1.00",
            billingContact: {
              addressLines: ["123 Main Street", "Apartment 1"],
              familyName: "Doe",
              givenName: "John",
              countryCode: "GB",
              city: "London",
            },
            currencyCode: "GBP",
            intent: "CHARGE",
          })}
        >
          <CreditCard/>
         
        </PaymentForm> 
      <iframe
        src="https://britishmuslimtrust.my.site.com/ReportIncident/"
        title="Report Incident"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default SearchEngine;
